/** @format */
import React, { useEffect } from 'react';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ReactNotifications } from 'react-notifications-component';
import '../node_modules/react-notifications-component/dist/theme.css';
import '../node_modules/animate.css/animate.min.css';
import {
  UserProvider,
  BusinessProvider,
  SaveOnPodSpaceDialogProvider,
  PageProvider,
  MenuProvider,
  ActionProvider,
} from 'providers';
import { RTL } from 'components';
import RoutesMain from 'Routes';
import theme from './theme';
import './assets/scss/index.scss';
import { loadTracker } from 'utility/LoadTracker';
const browserHistory = createBrowserHistory({ basename: process.env.PUBLIC_URL });

const App = () => {

  useEffect(() => {
    loadTracker()
  }, [])
  return (
    <RTL>
      <ThemeProvider theme={theme}>
        <CssBaseline />
      </ThemeProvider>
      <UserProvider>
        <ActionProvider>
          <MenuProvider>
            <BusinessProvider>
              <SaveOnPodSpaceDialogProvider>
                <PageProvider>
                  <ThemeProvider theme={theme}>
                    <ReactNotifications />
                    <RoutesMain />
                  </ThemeProvider>
                </PageProvider>
              </SaveOnPodSpaceDialogProvider>
            </BusinessProvider>
          </MenuProvider>
        </ActionProvider>
      </UserProvider>
    </RTL>
  );
};
export default App;
